import { razorpayOrderApi, razorpayVerifyApi } from "@/lib/api";

const SRC = "https://checkout.razorpay.com/v1/checkout.js";

function loadScript() {
  if (window.Razorpay) return Promise.resolve(true);
  return new Promise((resolve) => {
    const s = document.createElement("script");
    s.src = SRC;
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
}

export async function payWithRazorpay(packageId, interval, currency, { onSuccess, onError, onClose }) {
  if (!(await loadScript())) return onError("Couldn't load Razorpay. Check your connection.");
  let order;
  try {
    order = await razorpayOrderApi(packageId, interval, currency);
  } catch (e) {
    return onError(e.response?.data?.detail || "Could not start Razorpay checkout");
  }
  const rzp = new window.Razorpay({
    key: order.key_id,
    amount: order.amount,
    currency: order.currency,
    order_id: order.order_id,
    name: "SpeakToPrompt",
    description: `${order.plan_label} plan · ${order.interval === "yearly" ? "1 year" : "1 month"}`,
    prefill: { name: order.name, email: order.email },
    theme: { color: "#0071E3" },
    notes: { plan: order.plan_label, interval: order.interval },
    retry: { enabled: true },
    handler: async (res) => {
      try {
        await razorpayVerifyApi(res);
        onSuccess();
      } catch (e) {
        onError(e.response?.data?.detail || "Payment verification failed");
      }
    },
    modal: { ondismiss: onClose },
  });
  rzp.on("payment.failed", (r) => onError(r.error?.description || "Payment failed"));
  rzp.open();
}
